@if (print && filter) {
  <app-print-filter-data [filter]="filter" />
}

@if (data && data.labels?.length) {
  <div class="card">
    @if (!print) {
      <h3 class="title">Turno</h3>
    }

    <div class="summary">
      <div class="metric">
        <p>{{ totalResponses }} respostas</p>
      </div>
      <div class="metric satisfaction">
        <p>{{ overallSatisfaction }}% Satisfação</p>
      </div>
    </div>

    <div class="chart-container">
      <app-bar-chart
        [data]="data"
        text="Comparativo de Satisfação por Turno"
        [referenceValue]="overallSatisfaction"
        referenceLabel="Média de satisfação"
      />
    </div>
  </div>
} @else {
  <div class="empty">
    <p>Não há dados para exibir</p>
  </div>
}
